import { Card, Tree } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type AudiCalculationModuleSettingDataFragment } from '../../../../../api/fragments/AudiCalculationModuleSettingData';
import { type AudiCalculationModuleSpecsFragment } from '../../../../../api/fragments/AudiCalculationModuleSpecs';
import NoItemResult from '../../../../../components/results/NoItemResult';
import useTranslatedString from '../../../../../utilities/useTranslatedString';

type AudiCalculationSettingTabFinanceProductProps = {
    module: AudiCalculationModuleSpecsFragment;
    setting: AudiCalculationModuleSettingDataFragment;
};

const AudiCalculationSettingTabFinanceProduct = ({ module, setting }: AudiCalculationSettingTabFinanceProductProps) => {
    const { t } = useTranslation(['audiCalculationModuleDetails']);
    const translatedString = useTranslatedString();

    const treeData = useMemo(
        () =>
            setting.financeProducts.map(financeProduct => ({
                key: financeProduct.id,
                title: translatedString(financeProduct.legalName),
            })),
        [setting.financeProducts, translatedString]
    );

    if (treeData.length === 0) {
        return <NoItemResult subTitle={t('audiCalculationModuleDetails:tabs.financeProducts.noData')} />;
    }

    return (
        <Card>
            <Tree selectable={false} treeData={treeData} defaultExpandAll />
        </Card>
    );
};

export default AudiCalculationSettingTabFinanceProduct;
